export const Toolkit = {
  properties: {
    name: {
      type: "string",
      title: "Название тулкита",
    },
    url: {
      type: "string",
      title: "Ссылка на тулкит",
    },
    image: {
      type: "string",
      format: "image",
      title: "Изображение тулкита",
      examples: ["/upload/image.png"],
    },
    priority: {
      type: "integer",
      title: "Приоритет",
    },
  },
  type: "object",
  required: ["name", "url", "image", "priority"],
  title: "Создать тулкит",
};
